import { ConfigurationTypes } from '../../core/src/const/ConfigurationTypes';
import Configs from './Configs';
import { CurrencyType } from '../../core/src/managers/contracts/configurations/IBetConfig';
import ILocalConfig from '../../core/src/managers/contracts/configurations/ILocalConfig';
import BetModel from '../../core/src/model/BetModel';
import CurrencyUtils from '../../core/src/utils/CurrencyUtils';
import JackpotsModel from '../model/JackpotsModel';

class VendorLocalConfig implements ILocalConfig {
    type: ConfigurationTypes = ConfigurationTypes.LOCAL;
    overwritePatterns: { overwriteString: string; pattern: () => string; }[] = [
        {
            overwriteString: "rtp",
            pattern: () => Configs.game.getRTP().toString()
        },
        {
            overwriteString: "jackpot_fee",
            pattern: () => {
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(JackpotsModel.jackpotFee, BetModel.currencyLocalization, true);
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }
            }
        },
        {
            overwriteString: "progressive_jackpot_pool_reset_value",
            pattern: () => {
                const jackpotResetValue = 400;
                if (Configs.bet.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(jackpotResetValue, BetModel.currencyLocalization, true);
                } else {
                    return jackpotResetValue + " coins";
                }
            }
        }
    ];

}

export default new VendorLocalConfig()
